/* eslint-disable @typescript-eslint/naming-convention */
import { Component, OnInit } from '@angular/core';
import { ArticlesService } from '../../../services/articles.service';
import { Oneperweek } from '../../../services/oneperweek';
import { Logout } from '../../../services/logout.provider';
import { AuthProvider } from '../../../services/auth.provider';
import { StorageProvider } from '../../../services/storage.provider';
import { ConfigService } from '../../../services/config.service';
import { MetaProvider } from '../../../services/meta.provider';
import { PopUpService } from '../../../shared/components/pop-up/pop-up.service';
import { PopUp } from '../../../models/popup.model';
import { Multitenant } from '../../../services/multitenant.provider';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-thematicfiledetail',
  templateUrl: 'thematicfiledetail.html',
  styleUrls: ['thematicfiledetail.scss']
})
export class ThematicfiledetailPage implements OnInit {
  public thematicFileName: string;
  public thematicFiles: Array<any>;
  public thematicFilesSubCatSlug: string;
  public isClassLearn: any = false;
  public isClassTags: any = false;
  public isClassKeys: any = false;
  public error: string;
  public showOpenPerWeek: boolean;
  public isActivePage: string;
  public showPopUp: boolean;
  public popup: PopUp = new PopUp();
  public tempPopUp: boolean;
  public showSpinner: boolean;
  private access_token: string;
  private profileId: string;

  constructor(
    private actRoute: ActivatedRoute,
    private router: Router,
    private articlesService: ArticlesService,
    private oneperweek: Oneperweek,
    private logout: Logout,
    private auth: AuthProvider,
    private config: ConfigService,
    private storage: StorageProvider,
    private meta: MetaProvider,
    private popUpService: PopUpService,
    private multiTenant: Multitenant
  ) { }

  ngOnInit(): void {
    if (this.storage.getStorage('access_token')) {
      this.access_token = this.storage.getStorage('access_token');
    }

    if (this.storage.getStorage('logged_profile_id')) {
      this.profileId = this.storage.getStorage('logged_profile_id');
    }

    this.actRoute.queryParamMap.subscribe(params => this.thematicFileName = params.get('name'));
    this.actRoute.paramMap.subscribe( paramMap => this.getThematicFileDetail(paramMap.get('slug')));
  }

  ionViewWillEnter() {
    this.isActivePage = 'dossiers';
  }

  ionViewDidEnter() {
    this.meta.clearHead();
    if (!this.auth.isAuthenticated() && this.popUpService.havePassedSevenDays() && this.multiTenant.getDomainClass() === 'playbacpresse') {
      this.tempPopUp = true;
      this.popup.type = 'unIdentifiedUser';
    }
  }

  getThematicFileDetail(slug: string) {
    this.showSpinner = true;
    return this.articlesService.getThematicFileDetail(slug).subscribe(
        response => {
          this.thematicFiles = response;
          this.showSpinner = false;
        },
        (error) => {
          this.showSpinner = false;
          if (error.message === 'Invalid tokens.') {
            this.logout.logOut();
            this.router.navigate(['connexion']);
          }
          this.error = ' Vos identifiants ne sont pas reconnus';
        }
      );
  }

  openPdf(pdfId, newspaperSubname, pdfUrl) {
    if (!this.auth.isAuthenticated()) {
      this.router.navigate(['connexion']);
      return false;
    }

    this.oneperweek.checkOnePerWeek(pdfId, 'dossier');
    const pass = this.oneperweek.pass;
    if (!pass) {
      this.tempPopUp = true;
      this.popup.type = 'five';
      this.popup.data = this.oneperweek.remainingDays.toString();
    } else {
      if (this.auth.isAuthenticated()) {
        window.open(
          this.config.getApiDomainByEnv() +
            '/download?media=' + pdfId + '&entity=thematicFiles&access_token=' + this.access_token +
            '&newspaperSubname=' + newspaperSubname + '&profil=' + this.profileId,
            '_blank'
        );
      }
      if (!this.auth.isAuthenticated() && !this.auth.hasAccessTo()) {
        if (pdfUrl) {
          this.articlesService.pdfDownloadCounter(pdfId).subscribe(() => {});
          window.open(pdfUrl, '_blank');
        }
      }
    }
  }

  onNotifyDetailHeader(message: string): void {
    if (message === 'show') {
      this.tempPopUp = true;
      this.popup.type = 'featureToCome';
    }
  }

  onNotifyPopUp(message: string): void {
    this.tempPopUp = false;
  }
}
